import React, { createContext, useState } from "react";

import type { WebDocument } from "byzantine/src/dbbl/businessLogic/entities/documents/types";

type CheckboxState = {
  [documentId: string]: WebDocument;
};

type CheckboxContextType = {
  checkBoxState: CheckboxState;
  setCheckBoxState: React.Dispatch<React.SetStateAction<CheckboxState>>;
};

export const CheckboxContext = createContext({} as CheckboxContextType);

export const CheckboxProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [checkBoxState, setCheckBoxState] = useState<CheckboxState>({});

  return (
    <CheckboxContext.Provider value={{ checkBoxState, setCheckBoxState }}>
      {children}
    </CheckboxContext.Provider>
  );
};
